import React, { useCallback, useMemo, useState } from "react";
import type { ComponentType } from "react";
import { useStyles } from "./Calendar.styles";
import { BulkBaseIndexControlDateRange } from "../../BulkBaseIndexControl.types";
import { CalendarYear } from "../../../../../../../../../reportng/controls/CalendarYear";
import { CalendarQuarter } from "../../../../../../../../../reportng/controls/CalendarQuarter";
import { CalendarMonth } from "../../../../../../../../../reportng/controls/CalendarMonth";
import { CalendarWeek } from "../../../../../../../../../reportng/controls/CalendarWeek";
import type { ICalendarProps } from "./Calendar.types";

export function Calendar<T extends string | number | unknown>(props: ICalendarProps<T>) {
  const classes = useStyles();
  const { dateRange, value, onChange, disabled, items } = props;
  const valueAs = value as string;

  const calendarItems = useMemo(() => (disabled ? [] : items.map((x) => x as any)), [items]);

  let Component: ComponentType<any>;
  switch (dateRange) {
    case BulkBaseIndexControlDateRange.Annual:
      Component = CalendarYear;
      break;
    case BulkBaseIndexControlDateRange.Quarter:
      Component = CalendarQuarter;
      break;
    case BulkBaseIndexControlDateRange.Month:
      Component = CalendarMonth;
      break;
    case BulkBaseIndexControlDateRange.Week:
      Component = CalendarWeek;
      break;
    default:
      throw new Error("No calendar component set for date range");
  }

  const allYear = dateRange === BulkBaseIndexControlDateRange.Annual ? true : undefined;
  const labelFrom = "Date:";

  const commonProps = {
    allYear,
    disabled,
    items: calendarItems,
    dictionary: "",
  };

  return (
    <div className={classes.root}>
      <Component {...commonProps} label={labelFrom} onChange={onChange} value={valueAs} />
    </div>
  );
};
